import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ButtonType, ContentData, DialogType, ModalDialogService } from '@frontend/sports/modal/feature';
import { Observable, from } from 'rxjs';

export enum BetslipDialogFullMode {
    CannotAddMorePicks,
    CannotUndoRemovedPick,
}

@Injectable()
export class BetslipDigitalDialogFullService {
    constructor(
        private sitecore: Sitecore,
        private modalDialogService: ModalDialogService,
    ) {}

    show(mode: BetslipDialogFullMode = BetslipDialogFullMode.CannotAddMorePicks): Observable<ButtonType> {
        const modalDialogTexts = this.sitecore.modalDialogs;
        const contentData: ContentData = {
            type: DialogType.Warning,
            firstParagraph: this.getFirstParagraph(mode),
            secondParagraph: this.getSecondParagraph(mode),
            title: modalDialogTexts.betslipFull.DialogTitle,
            buttons: [
                {
                    type: ButtonType.Ok,
                    text: modalDialogTexts.betslipFull.DialogButtonText,
                    buttonConfig: {
                        kind: 'primary',
                        variant: 'filled',
                        size: 'large',
                    },
                },
            ],
        };

        return from(this.modalDialogService.openMessage(contentData).result);
    }

    private getFirstParagraph(mode: BetslipDialogFullMode): string {
        switch (mode) {
            case BetslipDialogFullMode.CannotAddMorePicks:
                return this.sitecore.modalDialogs.betslipFull.DialogText1;
            case BetslipDialogFullMode.CannotUndoRemovedPick:
                return this.sitecore.betslip.editBet.betslipFullCannotUndoDialogText1;
            default:
                throw new Error(`Unknown BetslipDialogFullMode: ${mode}`);
        }
    }

    private getSecondParagraph(mode: BetslipDialogFullMode): string {
        switch (mode) {
            case BetslipDialogFullMode.CannotAddMorePicks:
                return this.sitecore.modalDialogs.betslipFull.DialogText2;
            case BetslipDialogFullMode.CannotUndoRemovedPick:
                return this.sitecore.betslip.editBet.betslipFullCannotUndoDialogText2;
            default:
                throw new Error(`Unknown BetslipDialogFullMode: ${mode}`);
        }
    }
}
